import styled from 'styled-components/macro';

export const SocialLoginContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.appComponents.loginMigrations.redisBackground.color};
`;
